<script lang="ts" module>
	import type { VariantProps } from 'tailwind-variants';
	import { Checkbox } from 'bits-ui';
	import { tv } from '../tv';
	import { CROSS_SIZE_VARIANTS, MAIN_COLOR_VARIANTS } from '../variants';
	import Icon from '../icon/icon.svelte';
	import { Icons } from '../icon/icons';

	export const checkboxVariants = tv({
		base: 'relative inline-flex shrink-0 items-center justify-center',
		variants: { size: CROSS_SIZE_VARIANTS, variant: MAIN_COLOR_VARIANTS },
		defaultVariants: { size: '400', variant: 'Secondary' }
	});

	export type CheckboxProps = Omit<Checkbox.RootProps, 'child' | 'children'> &
		VariantProps<typeof checkboxVariants>;
</script>

<script lang="ts">
	let {
		checked = $bindable(false),
		class: className,
		indeterminate = $bindable(false),
		onCheckedChange,
		ref = $bindable(null),
		size,
		style,
		variant,
		...rest
	}: CheckboxProps = $props();
</script>

<span class={[checkboxVariants({ size, variant }), className]} {style}>
	<Checkbox.Root
		bind:checked
		bind:indeterminate
		bind:ref
		class="peer rounded-r300 not-data-[state=checked]:opacity-p300 focus-outline disabled-state absolute size-full cursor-pointer [box-shadow:inset_0_0_0_var(--border-width-b400)_currentColor] data-[state=checked]:bg-(--v-main) data-[state=checked]:[box-shadow:none]"
		{onCheckedChange}
		{...rest}
	/>
	<Icon
		aria-hidden="true"
		class="peer-data-disabled:opacity-disabled pointer-events-none absolute text-transparent peer-data-[state=checked]:text-(--v-on-main)"
		{size}
		src={Icons.Check}
	/>
</span>
